import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/Logo.svg";
import "./style.css";
import { forgotPasswordAPI } from "../../../API/auth";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    const response = await forgotPasswordAPI(values?.email);

    if (Math.floor(response?.status / 100) === 2) {
      message.success("Password Reset email sent!");
    } else {
      message.error(response?.data?.message || "Something went wrong");
    }

    setLoading(false);
  };

  const handleBackToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="forgot">
      <div className="forgot-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <div className="forgot-card">
          <div className="content-heading">Forgot Your Password</div>
          <div className="sub-heading">
            Enter your email address and we will send you a link to reset your
            password
          </div>
          <Form
            name="register"
            layout="vertical"
            autoComplete="off"
            onFinish={onFinish}
          >
            <Form.Item
              label="Email Address"
              name="email"
              rules={[
                { required: true, message: "Please enter your email!" },
                { type: "email", message: "Enter a valid email!" },
              ]}
            >
              <Input
                placeholder="Enter your email address"
                prefix={<MailOutlined />}
              />
            </Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="submit-button"
              loading={loading}
            >
              Send Recovery Email
            </Button>
          </Form>
        </div>
        <div className="back-to-login" onClick={handleBackToLogin}>
          <ArrowLeftOutlined />
          Back to Login
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
